import { j as t } from "./index58.mjs";
import { PasswordInput as m, Input as i } from "@mantine/core";
import { QuestionMarkCircledIcon as n } from "./index59.mjs";
import { forwardRef as d } from "react";
import { Tooltip as c } from "./index17.mjs";
function u(e) {
  return {
    size: "md",
    radius: "sm",
    className: `relative ${e.error ? "animate-shake" : ""} ${e.className}`,
    label: e.label,
    error: e.error,
    description: e.description ? /* @__PURE__ */ t.jsxs("div", { className: "text-xs mb-2", children: [
      e.description,
      e.tooltip && /* @__PURE__ */ t.jsx(c, { className: "absolute right-0 top-1.5", label: e.tooltip, children: /* @__PURE__ */ t.jsx(n, {}) })
    ] }) : void 0,
    classNames: {
      error: "text-sm",
      label: "text-sm",
      input: "dark:bg-dark-900 my-2"
    }
  };
}
const I = d((e, o) => {
  const {
    password: l,
    tooltip: x,
    color: a = e.error ? "red" : void 0,
    ...s
  } = e, r = u(s);
  return l ? /* @__PURE__ */ t.jsx(m, { ...r, ...s, className: r.className }) : (a && (r.styles = {
    ...r.styles,
    // @ts-ignore
    input: {
      border: "1px solid " + a
    }
  }), /* @__PURE__ */ t.jsx(i.Wrapper, { ...r, required: e.required, children: /* @__PURE__ */ t.jsx(
    i,
    {
      ref: o,
      ...r,
      ...s,
      className: r.className
    }
  ) }));
});
export {
  I as Input,
  u as getInputDefaults
};
